import { createContext } from 'react';

export const initialState = {
    apiUrl: 'crmDealFront',
    defaultFilters: {
        Status: {
            id: 'null',
            name: 'OPEN',
        },
        Personal: {
            id: '',
            name: 'Alla',
        },
    },
    activeDeals: [],
    activeDeal: null,
    pipelines: {}, //key : value   "pipelines"
    currentPipelineId: '',
    currentPipelineStageId: '',
    userFilterType: { id: 'user', name: 'Användare', icon: 'user' },
    selectedUsersOptions: null,
    selectedUserGroupOption: null,
    selectedBossGroupOption: null,
    selectedTeamGroupOption: null,
    initialViewSettings: {
        minIndex: 0,
        maxIndex: 0,
        itemHeight: 130,
        totalHeight: 0,
        bufferHeight: 0,
        topPaddingHeight: 0,
        bottomPaddingHeight: 0,
        tolerance: 3,
    },
    initialRequestObject: {
        startIndex: 0,
        amount: 7,
        tolerance: 3,
        filters: {},
        pipelineStageIds: [],
    },
};

export const reducer = (state, action) => {
    switch (action.type) {
        case 'UPDATE_FETCH_PIPES':
            return {
                ...state,
                pipelines: action.pipelines,
            };
        case 'UPDATE_CURRENT_PIPE_ID':
            return {
                ...state,
                currentPipelineId: action.pipelineId,
            };
        case 'UPDATE_CURRENT_PIPE_STAGE_ID':
            return {
                ...state,
                currentPipelineStageId: action.pipelineStageId,
            };
        case 'UPDATE_ACTIVE_DEALS':
            return {
                ...state,
                activeDeals: action.payload,
            };
        case 'UPDATE_ACTIVE_DEAL':
            return {
                ...state,
                activeDeal: action.payload,
            };
        case 'UPDATE_DEALS_AND_ACTIVE_DEALS':
            return {
                ...state,
                deals: action.deals,
                activeDeal: action.activeDeal,
            };
        case 'SET_USER_FILTER_TYPE':
            return {
                ...state,
                userFilterType: action.payload,
            };
        case 'SET_SELECTED_USERS_OPTIONS':
            return {
                ...state,
                selectedUsersOptions: action.payload,
            };
        case 'SET_SELECTED_USER_GROUP_OPTION':
            return {
                ...state,
                selectedUserGroupOption: action.payload,
            };
        case 'SET_SELECTED_BOSS_GROUP_OPTION':
            return {
                ...state,
                selectedBossGroupOption: action.payload,
            };
        case 'SET_SELECTED_TEAM_GROUP_OPTION':
            return {
                ...state,
                selectedTeamGroupOption: action.payload,
            };
        default:
            console.error(action.type + ', cant use anymore!');
            return state;
    }
};

export const DataContext = createContext(initialState);
